module.exports = __webpack_public_path__ + "img/trezor.3ae90c99.svg";